"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerContent = void 0;
const styled_1 = require("../../tools/styled");
const Box_1 = require("../Box");
exports.DrawerContent = styled_1.styled(Box_1.Box) `
  overflow-y: auto;

  ::-webkit-scrollbar {
    display: none;
  }
`;
//# sourceMappingURL=index.js.map